import globalApi from "../../app/GlobalApi";






const memberApi = globalApi.injectEndpoints({
  endpoints: (builder) => ({
  
 
    getMembers: builder.query({
        
    query: () => ({
      url: `/team`,
      method: 'GET',
    }),

}),
})

})
export const { useGetMembersQuery} = memberApi;
